<template>
	<div no-gutters @click="onClick">
		<v-row no-gutters>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12: 1">
				<div class="mx-2">Bulk&nbsp;Actions</div>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12: 4">
				<div class="bulk-container mx-4">
					<span class="mr-1">Assigned:</span>
					<AssignedTreeSelection
						style="width: 100%"
						:color="color"
						:bgColor="'white'"
						:selected="bulk_assigned_local"
						:closeSelection="close_selection"
						:disabled="!isPrivilege"
						:kinds="bulk_kind"
						@assign-selected="bulk_assigned_local = $event"
					/>
				</div>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12: 4">
				<div class="bulk-container">
					<span class="mr-1">Status:</span>
					<v-select
						v-model="bulk_status_local"
						:color="color"
						:items="statuses"
						item-text="desc"
						item-value="id"
						item-color="success"
						append-icon="mdi-chevron-down"
						:placeholder="bulk_status.length === 1 ? bulk_status[0].desc : 'Mixed'"
						background-color="white"
						outlined
						dense
						hide-details
						return-object
						:disabled="!isPrivilege"
						@change="onStatusChanged($event)"
					></v-select>
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import AssignedTreeSelection from "@/components/jobs/assigned_tree_selection.vue";

const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;
const FREELANCER = 4;

export default {
	name: 'TaskBulk',
	props: {
		color: {
			type: String,
			default: ''
		},
		statuses: {
			type: Array,
			default: () => []
		},
		isPrivilege: {
			type: Boolean,
			default: true
		},
		bulk_assigned: {
			type: Array,
			default: () => []
		},
		bulk_status: {
			type: Array,
			default: () => []
		},
		bulk_kind: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			close_selection: 0,
			bulk_assigned_local: this._buildAssigned(this.bulk_assigned),
			bulk_assigned_local_origin: this._buildAssigned(this.bulk_assigned),
			bulk_status_local: [],
		}
	},
	components: {
		AssignedTreeSelection
	},
	watch: {
		bulk_assigned() {
			this.bulk_assigned_local = this._buildAssigned(this.bulk_assigned);
			this.bulk_assigned_local_origin = this._buildAssigned(this.bulk_assigned);
		}
	},
	methods: {
		onClick() {
			this.close_selection += 1;

			if (this.bulk_assigned_local.length !== this.bulk_assigned_local_origin.length) {
				const dest_assigned = this._buildAssignedParams(this.bulk_assigned_local);
				this.$emit('assigned-change', dest_assigned);
			} else {
				const all_ids_origin = this.bulk_assigned_local_origin.map(b => { return b.id });
				const all_ids = this.bulk_assigned_local.map(b => { return b.id });
				for (let index = 0; index < all_ids.length; index++) {
					const element = all_ids[index];
					if (!all_ids_origin.includes(element)) {
						const dest_assigned = this._buildAssignedParams(this.bulk_assigned_local);
						this.$emit('assigned-change', dest_assigned);
						return;
					}
				}
			}
		},
		onStatusChanged(status) {
			this.$emit('status-change', status);
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		_buildAssigned(array) {
			let result_arr = [];
			array.forEach(a => {
				const obj = {};
				if (a.Type === ALLEMPLOYEES) {
					let display_name = this.formatName(a.DisplayName);
					obj['id'] = `${a.is_freelancer && !a.is_employee ? FREELANCER : ALLEMPLOYEES}_${a.AbookId}`,
					obj['type'] = a.is_freelancer && !a.is_employee ? FREELANCER : a.Type,
					obj['name'] = display_name
				}
				if (a.Type === ROLES) {
					obj['id'] = `${ROLES}_${a.RoleId}`,
					obj['type'] = a.Type,
					obj['name'] = a.DisplayName
				}
				if (a.Type === DEPARTMENTS) {
					obj['id'] = `${DEPARTMENTS}_${a.DepartmentId}` ,
					obj['type'] = a.Type,
					obj['name'] = a.DisplayName
				}
				result_arr.push(obj);
			});

			const map_res = new Map();
			result_arr.forEach(s => {
				if (!map_res.has(s.id)) {
					map_res.set(s.id, s);
				}
			});
			result_arr = [...map_res.values()];
	
			return result_arr;
		},
		_buildAssignedParams(array) {
			const assigned_tmp = [];
			if (array.length !== 0) {
				array.forEach(a => {
					const assigned_id = typeof(a.id) === 'string' ? a.id : a.id.toString();
					const assigned_id_split = assigned_id.split('_');

					if (assigned_id_split.length > 1) {
						const assigned_obj = {};
						const mode = Number(assigned_id_split[0]) === FREELANCER ? ALLEMPLOYEES : assigned_id_split[0];
						assigned_obj['mode'] = Number(mode);

						if (Number(mode) === DEPARTMENTS) {
							assigned_obj['department_id'] = Number(assigned_id_split[1]);
						}

						if (Number(mode) === ROLES) {
							assigned_obj['role_id'] = Number(assigned_id_split[1]);
						}

						if (Number(mode) === ALLEMPLOYEES) {
							assigned_obj['abook_id'] = Number(assigned_id_split[1]);
						}

						assigned_tmp.push(assigned_obj);
					}
				});
			}

			return assigned_tmp;
		}
	}
}
</script>
<style lang="scss" scoped>
.bulk-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>